export default __webpack_public_path__ + "static/media/banner-staking.547ed990.png";